import { createSelector } from 'reselect';
import type { RootState } from './Store';
import { PersonaReactions } from '../data/Reactions';
import {
	getAllActiveConcepts,
	getAllInactiveConcepts,
	getAllPersonas,
	getCurrentRoundIndex,
	getFinishedRounds,
	getFinishedRoundsCount,
	getLastFinishedRound,
	getPersonaScores,
	getPreviousRounds,
	getTotalScore,
	isPlaythroughFinished
} from './PlaythroughSlice';
import { getSortedEntries } from './HighscoreSlice';

const highscoreEntriesSelector = (state: RootState) => state.highscore.entries;
export const sortedEntriesSelector = createSelector(
	highscoreEntriesSelector,
	(entries) => getSortedEntries(entries)
);

const playthroughSelector = (state: RootState) => state.playthrough;
export const isPlaythroughFinishedSelector = createSelector(
	playthroughSelector,
	(playthrough) => isPlaythroughFinished(playthrough)
);
export const currentCategorySelector = createSelector(
	playthroughSelector,
	(playthrough) => playthrough.currentCategory
);

const playthroughRoundsSelector = (state: RootState) =>
	state.playthrough.rounds;
// Personas
export const currentPersonasSelector = createSelector(
	playthroughRoundsSelector,
	(rounds) => getAllPersonas(rounds)
);

// Concepts
export const currentActiveConceptsSelector = createSelector(
	playthroughRoundsSelector,
	(rounds) => getAllActiveConcepts(rounds)
);
export const currentInactiveConceptsSelector = createSelector(
	playthroughRoundsSelector,
	(rounds) => getAllInactiveConcepts(rounds)
);

// Rounds
export const currentRoundIndexSelector = createSelector(
	playthroughRoundsSelector,
	(rounds) => getCurrentRoundIndex(rounds)
);
export const finishedRoundsSelector = createSelector(
	playthroughRoundsSelector,
	(rounds) => getFinishedRounds(rounds)
);
export const finishedRoundsCountSelector = createSelector(
	playthroughRoundsSelector,
	(rounds) => getFinishedRoundsCount(rounds)
);
export const lastFinishedRoundSelector = createSelector(
	playthroughRoundsSelector,
	(rounds) => getLastFinishedRound(rounds)
);

// Scores
export const personaScoresForLastFinishedRoundSelector = createSelector(
	playthroughRoundsSelector,
	(rounds) => getPersonaScores(getLastFinishedRound(rounds))
);
export const currentTotalScoreSelector = createSelector(
	playthroughRoundsSelector,
	(rounds) => getTotalScore(getFinishedRounds(rounds))
);
export const previousTotalScoreSelector = createSelector(
	playthroughRoundsSelector,
	(rounds) => getTotalScore(getPreviousRounds(getFinishedRounds(rounds)))
);

// Reactions
export const personaReactionsForLastFinishedRoundSelector = createSelector(
	playthroughRoundsSelector,
	(rounds) =>
		PersonaReactions.fromScores(getPersonaScores(getLastFinishedRound(rounds)))
);
